import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { BusinessCardUrlWithParamsPipe, CompanySearchSortPipe, WeekDayPipe } from '@warema/shared/pipes';
import { GoogleService } from '@warema/shared/services';
import { SharedSvgModule } from '@warema/shared/svg';
import { CompanyBadgesComponent } from './company-badges/company-badges.component';
import { CompanySearchResultComponent } from './company-search-result/company-search-result.component';
import { FindMeBtnComponent } from './find-me-btn/find-me-btn.component';
import { GoogleMapComponent } from './google-map/google-map.component';
import { NoAppointmentRequestSearchResultsComponent } from './no-appointment-request-search-results/no-appointment-request-search-results.component';
import { NoOfferRequestSearchResultsComponent } from './no-offer-request-search-results/no-offer-request-search-results.component';
import { RatingStarsComponent } from './rating-stars/rating-stars.component';
import { SearchInstructionsComponent } from './search-instructions/search-instructions.component';
import { SortingCriteriaComponent } from './sorting-criteria/sorting-criteria.component';

@NgModule({
    exports: [
        CompanySearchResultComponent,
        RatingStarsComponent,
        GoogleMapComponent,
        SortingCriteriaComponent,
        FindMeBtnComponent,
        SearchInstructionsComponent,
        NoOfferRequestSearchResultsComponent,
        NoAppointmentRequestSearchResultsComponent,
    ],
    imports: [
        CommonModule,
        SharedSvgModule,
        GoogleMapsModule,
        WeekDayPipe,
        BusinessCardUrlWithParamsPipe,
        CompanySearchSortPipe,
        CompanySearchResultComponent,
        RatingStarsComponent,
        CompanyBadgesComponent,
        GoogleMapComponent,
        SortingCriteriaComponent,
        FindMeBtnComponent,
        SearchInstructionsComponent,
        NoOfferRequestSearchResultsComponent,
        NoAppointmentRequestSearchResultsComponent,
    ],
    providers: [GoogleService, provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())],
})
export class WaremaSharedCompanySearchUiModule {}
